import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
} from '../../components/Form';


import {
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersPeikConfirmOrder(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formAccountingOne, setFormAccountingOne] = useState(null);
    const [formAccountingTwo, setFormAccountingTwo] = useState(null);
    const [formAccountingThree, setFormAccountingThree] = useState(null);
    const [formAccountingCash, setFormAccountingCash] = useState(null);
    const [formAccountingShortage, setFormAccountingShortage] = useState(null);
    const [formAccountingRound, setFormAccountingRound] = useState(null);
    const [formAccountingFour, setFormAccountingFour] = useState(null);
    const [formViewTextPayablePrice, setFormViewTextPayablePrice] = useState(null);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleConfirmOrder = async () => {
        await postData('/api/panel/page/taroff-orders-peik-confirm-order/save-data', {
            id: allProps['taroff-orders-id'],
            accounting_one: formAccountingOne,
            accounting_two: formAccountingTwo,
            accounting_three: formAccountingThree,
            accounting_cash: formAccountingCash,
            accounting_shortage: formAccountingShortage,
            accounting_round: formAccountingRound,
            accounting_four: formAccountingFour,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-confirm-order/form-data', {
            id: allProps['taroff-orders-id'],
        }).then((response) => {
            setFormAccountingOne(response.data.accounting_one);
            setFormAccountingTwo(response.data.accounting_two);
            setFormAccountingThree(response.data.accounting_three);
            setFormAccountingCash(response.data.accounting_cash);
            setFormAccountingShortage(response.data.accounting_shortage);
            setFormAccountingRound(response.data.accounting_round);
            setFormAccountingFour(response.data.accounting_four);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش سفارش</Title>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'پوز 1'}
                            value={formAccountingOne}
                            onChange={setFormAccountingOne}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'پوز 2'}
                            value={formAccountingTwo}
                            onChange={setFormAccountingTwo}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'پوز 3'}
                            value={formAccountingThree}
                            onChange={setFormAccountingThree}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'مالی نقد'}
                            value={formAccountingCash}
                            onChange={setFormAccountingCash}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'مالی کسری'}
                            value={formAccountingShortage}
                            onChange={setFormAccountingShortage}
                        />
                    </GridColumn>
                    <GridColumn width={6}>
                        <TextBox
                            label={'مالی رند'}
                            value={formAccountingRound}
                            onChange={setFormAccountingRound}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={6}>
                        <TextBox
                            label={'پوز روز'}
                            value={formAccountingFour}
                            onChange={setFormAccountingFour}
                        />
                    </GridColumn>
                    <GridColumn width={6}></GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextView>سفارش به وضعیت تایید شده مالی منتقل شود ؟ مبلغ سفارش : </TextView>
                        <TextView>{formViewTextPayablePrice}</TextView>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handleCancel}>انصراف</Button>
                    <Button onClick={handleConfirmOrder}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
